module.exports = __webpack_public_path__ + "static/bg-dde2b42fc0b0c89a602762d46de36d7b.png";